import { combineReducers, Action } from "redux";

// Reducer's import
import userReducer from "./user/userReducer";
import menuReducer from "./menu/menuReducer";
import countryReducer from "./country/countryReducer";
import statusRegisterReducer from "./statusRegister/statusRegisterReducer";
import companyTypeReducer from "./companyType/companyTypeReducer";
import companyReducer from "./company/companyReducer";
import companyBranchReducer from "./companyBranch/companyBranchReducer";
import bodyshopReducer from "./bodyshop/bodyshopReducer";
import bodyshopBranchReducer from "./bodyshopBranch/bodyshopBranchReducer";
import insurerReducer from "./insurer/insurerReducer";
import insuranceSublineReducer from "./insuranceSubline/insuranceSublineReducer";
import supplierReducer from "./supplier/supplierReducer";
import modalReducer from "./modal/modalReducer";
import stateReducer from "./state/stateReducer";
import translateReducer from "./translate/translateReducer";
import cultureReducer from "./culture/cultureReducer";
import userGroupReducer from "./userGroup/userGroupReducer";
import timeZoneReducer from "./timeZone/timeZoneReducer";
import contactTypeReducer from "./contactType/contactTypeReducer";
import municipalityReducer from "./municipality/municipalityReducer";
import addressTypeReducer from "./addressType/addressTypeReducer";
import supplierTypeReducer from "./supplierType/supplierTypeReducer";
import supplierCategoryReducer from "./supplierCategory/supplierCategoryReducer";
import yearReducer from "./vehicle/year/yearReducer";
import manufacturerReducer from "./vehicle/manufacturer/manufacturerReducer";
import modelReducer from "./vehicle/model/modelReducer";
import subModelReducer from "./vehicle/subModel/subModelReducer";
import damageAreaReducer from "./damageArea/damageAreaReducer";
import addressByBodyshopReducer from "./addressByBodyshop/addressByBodyshopReducer";
import cartReducer from "./cart/cartReducer";
import partTypeReducer from "./partType/partTypeReducer";
import controlReducer from "./control/controlReducer";
import categoryReducer from "./category/categoryReducer";
import quoteStatusReducer from "./quoteStatus/quoteStatusReducer";
import claimTypeReducer from "./claimType/claimTypeReducer";
import reasonReducer from "./reason/reasonReducer";
import distributionRegionReducer from "./distributionRegion/distributionRegionReducer";
import quoteCountStatusReducer from "./quoteCountStatus/quoteCountStatusReducer";
import summaryReducer from "./summary/summaryReducer";
import cartStatusReducer from "./cartStatus/cartStatusReducer";
import cartCountStatusReducer from "./cartCountStatus/cartCountStatusReducer";
import billingAddressReducer from "./billingAddress/billingAddressReducer";
import warehouseReducer from "./warehouse/warehouseReducer";
import brandReducer from "./brand/brandReducer";
import packageReducer from "./package/packageReducer";
import supplierInventoryImportStatusReducer from "./supplierInventoryImportStatus/supplierInventoryImportStatusReducer";
import supplierInventoryWarehouseStatusReducer from "./supplierInventoryWarehouseStatus/supplierInventoryWarehouseStatusReducer";
import subcategoryReducer from "./subcategory/subcategoryReducer";
import positionReducer from "./position/positionReducer";
import parameterTypeValueReducer from "./parameterTypeValue/parameterTypeValueReducer";
import dragDropScreenReducer from "./dragDropScreen/dragDropScreenReducer";
import quoteImportStatusReducer from "./quoteImportStatus/quoteImportStatusReducer";
import integrationTriggerReducer from "./integrationTrigger/integrationTriggerReducer";
import integrationTypeReducer from "./integrationType/integrationTypeReducer";
import integrationQueueStatusReducer from "./integrationQueueStatus/integrationQueueStatusReducer";
import mappingTypeReducer from "./mappingType/mappingTypeReducer";
import queryParamsReducer from "./queryParams/queryParamsReducer";
import assessmentTypeReducer from "./assessmentType/assessmentTypeReducer";
import reportTemplateReducer from "./reportTemplate/reportTemplateReducer";
import reportTemplateTypeReducer from "./reportTemplateType/reportTemplateTypeReducer";
import managePackagesCountStatusReducer from "./managePackagesCountStatus/managePackagesCountStatusReducer";
import parameterByTypeScreenReducer from "./parameterByTypeScreen/parameterByTypeScreenReducer";
import signalRReducer from "./signalR/signalRReducer";
import addressReducer from "./address/addressReducer";
import userTypeReducer from "./userType/userTypeReducer";
import claimFileCategoryReducer from "./claimFileCategory/claimFileCategoryReducer";

import { UserTypes } from "./user";
import { ApplicationState } from "./rootStore";
import reportScheduleStatusReducer from "./reportScheduleStatus/reportScheduleStatusReducer";
import schedulerUsersReducer from "./schedulerUsers/schedulerUsersReducer";
import deliveryTypeReducer from "./deliveryType/deliveryTypeReducer";
import preQuoteTypeReducer from "./preQuoteType/preQuoteTypeReducer";
import systemApplicationReducer from "./systemApplication/systemApplicationReducer";
import valuatorReducer from "./valuator/valuatorReducer";
import supervisorReducer from "./supervisor/supervisorReducer";
import parameterReducer from "./parameter/parameterReducer";
import damageCategoryReducer from "./damageCategory/damageCategoryReducer";
import bodyshopTypeReducer from "./bodyshopType/bodyshopTypeReducer";
import entityTypeReducer from "./entityType/entityTypeReducer";
import companyManufacturerReducer from "./companyManufacturer/companyManufacturerReducer";
import affectedTypeReducer from "./affectedType/affectedTypeReducer";
import rateImportStatusReducer from "./rateImportStatus/rateImportStatusReducer";
import requestFormatReducer from "./RequestFormat/requestFormatReducer";
import excludeVariablesReducer from "./excludeVariables/excludeVariablesReducer";
import visualIdentityReducer from "./visualIdentity/visualIdentityReducer";
import templateEmailNotificationReducer from "./templateEmailNotification/templateEmailNotificationReducer";
import announcementReducer from "./announcement/announcementReducer";
import accessErrorReducer from "./accessError/accessErrorReducer";
import predefinedSearchReducer from "./predefinedSearch/predefinedSearchReducer";
import domainUsersByCompanyReducer from "./domainUsersByCompany/domainUsersByCompanyReducer";
import partBrandReducer from "@/main/store/partBrand/partBrandReducer";
import fileTypeReducer from "@/main/store/fileType/fileTypeReducer";
import automaticActionReducer from "@/main/store/automaticAction/automaticActionReducer";
import approvalMatrixTypeReducer from "@/main/store/approvalMatrixType/approvalMatrixTypeReducer";
import userHierarchyReducer from "@/main/store/userHierarchy/userHierarchyReducer";
import voucherTypeReducer from "@/main/store/voucherType/voucherTypeReducer";
import voucherRefundStatusReducer from "@/main/store/voucherRefundStatus/voucherRefundStatusReducer";

export type RootState = ReturnType<typeof AppReducer>;

const AppReducer = combineReducers({
	user: userReducer,
	menu: menuReducer,
	company: companyReducer,
	companyType: companyTypeReducer,
	companyBranch: companyBranchReducer,
	country: countryReducer,
	culture: cultureReducer,
	statusRegister: statusRegisterReducer,
	bodyshop: bodyshopReducer,
	bodyshopBranch: bodyshopBranchReducer,
	insurer: insurerReducer,
	insuranceSubline: insuranceSublineReducer,
	supplier: supplierReducer,
	stateCountry: stateReducer,
	modal: modalReducer,
	translate: translateReducer,
	userGroup: userGroupReducer,
	timeZone: timeZoneReducer,
	contactType: contactTypeReducer,
	municipality: municipalityReducer,
	addressType: addressTypeReducer,
	supplierType: supplierTypeReducer,
	supplierCategory: supplierCategoryReducer,
	year: yearReducer,
	manufacturer: manufacturerReducer,
	model: modelReducer,
	subModel: subModelReducer,
	damageArea: damageAreaReducer,
	addressByBodyshop: addressByBodyshopReducer,
	cart: cartReducer,
	partType: partTypeReducer,
	control: controlReducer,
	category: categoryReducer,
	quoteStatus: quoteStatusReducer,
	claimType: claimTypeReducer,
	reason: reasonReducer,
	distributionRegion: distributionRegionReducer,
	quoteCountStatus: quoteCountStatusReducer,
	summary: summaryReducer,
	cartStatus: cartStatusReducer,
	cartCountStatus: cartCountStatusReducer,
	billingAddress: billingAddressReducer,
	warehouse: warehouseReducer,
	brand: brandReducer,
	package: packageReducer,
	supplierInventoryImportStatus: supplierInventoryImportStatusReducer,
	supplierInventoryWarehouseStatus: supplierInventoryWarehouseStatusReducer,
	subcategory: subcategoryReducer,
	position: positionReducer,
	parameterTypeValue: parameterTypeValueReducer,
	dragDropScreen: dragDropScreenReducer,
	quoteImportStatus: quoteImportStatusReducer,
	integrationTrigger: integrationTriggerReducer,
	integration: integrationTypeReducer,
	integrationQueueStatus: integrationQueueStatusReducer,
	mappingType: mappingTypeReducer,
	queryParams: queryParamsReducer,
	assessmentType: assessmentTypeReducer,
	managePackagesCountStatus: managePackagesCountStatusReducer,
	parameterByTypeScreen: parameterByTypeScreenReducer,
	signalR: signalRReducer,
	address: addressReducer,
	reportScheduleStatus: reportScheduleStatusReducer,
	schedulerUsers: schedulerUsersReducer,
	userType: userTypeReducer,
	deliveryTypes: deliveryTypeReducer,
	preQuoteType: preQuoteTypeReducer,
	systemApplication: systemApplicationReducer,
	valuator: valuatorReducer,
	supervisor: supervisorReducer,
	parameter: parameterReducer,
	damageCategory: damageCategoryReducer,
	bodyshopType: bodyshopTypeReducer,
	entityType: entityTypeReducer,
	companyManufacturer: companyManufacturerReducer,
	affectedType: affectedTypeReducer,
	rateImportStatus: rateImportStatusReducer,
	requestFormat: requestFormatReducer,
	reportTemplate: reportTemplateReducer,
	reportTemplateType: reportTemplateTypeReducer,
	claimFileCategory: claimFileCategoryReducer,
	excludeVariables: excludeVariablesReducer,
	visualIdentity: visualIdentityReducer,
	templateEmailNotification: templateEmailNotificationReducer,
	announcement: announcementReducer,
	accessError: accessErrorReducer,
	predefinedSearch: predefinedSearchReducer,
	domainUsersByCompany: domainUsersByCompanyReducer,
	partBrand: partBrandReducer,
	fileType: fileTypeReducer,
	automaticAction: automaticActionReducer,
	approvalMatrixType: approvalMatrixTypeReducer,
	userHierarchy: userHierarchyReducer,
	voucherType: voucherTypeReducer,
	voucherRefundStatus: voucherRefundStatusReducer,
});

const RootReducer = (state: ApplicationState, action: Action) => {
	if (action.type === UserTypes.USER_ISLOGOUT) {
		return AppReducer(undefined, action);
	}

	return AppReducer(state, action);
};

export default RootReducer;
